import React from 'react';
import useLogout from "@User/hooks/useLogout";
import {useAsyncHandler} from "@Hooks/promises/useAsyncHandler";
import Translation from "@Translation/components/Translation";
import IconSignIn from "@Icons/login/IconSignIn";

function LogoutButton() {
    const logout = useLogout()
    const handleLogout = useAsyncHandler(logout)

    return (
        <button
            type="button"
            onClick={handleLogout}
            className={"buyer-info__login"}
        >
            <IconSignIn
                width="20"
                height="20"
                style={{
                    verticalAlign: 'middle',
                    transform: 'scale(-1)',
                }}
            />
            <Translation translationKey="user.logout"/>
        </button>
    );
}

export default LogoutButton;